var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("SoliForm", {
        ref: "form",
        attrs: {
          title: `${_vm.editing ? "Edit" : "Create"} Lead`,
          "limit-scroll": _vm.$vuetify.breakpoint.sm,
          "mobile-scroll": _vm.$vuetify.breakpoint.xs,
          errors: _vm.errors,
          loadingProp: _vm.form.loading,
          saveChanges: (_vm.edited || !_vm.editing) && !_vm.form.readonly,
          disabled: _vm.form.readonly,
          persistent: "",
          text: "Save",
          icon: "save",
        },
        on: {
          reset: function ($event) {
            return _vm.$emit("reset")
          },
          submit: _vm.submit,
        },
        scopedSlots: _vm._u([
          {
            key: "subtitle",
            fn: function () {
              return [
                !_vm.form.readonly && _vm.editing
                  ? _c(
                      "v-btn",
                      {
                        attrs: {
                          rounded: "",
                          "x-small": "",
                          outlined: "",
                          color: "accent",
                          disabled: _vm.edited,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleConversion(false)
                          },
                        },
                      },
                      [_vm._v("Convert To User")]
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "tabs",
            fn: function () {
              return [
                _vm.form.children.length && !_vm.loading
                  ? _c(
                      "v-card-subtitle",
                      {
                        staticClass: "pb-0",
                        class: { "pt-0": !_vm.form.readonly },
                      },
                      [
                        _vm.form.readonly
                          ? _c("p", { staticClass: "caption soli-grey mb-0" }, [
                              _vm._v(
                                "\n                    This lead has converted to a customer and can no longer\n                    be edited.\n                "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "v-tabs",
                          {
                            attrs: { touchless: "" },
                            model: {
                              value: _vm.tab,
                              callback: function ($$v) {
                                _vm.tab = $$v
                              },
                              expression: "tab",
                            },
                          },
                          [
                            _c("v-tab", [_vm._v("Info")]),
                            _vm._v(" "),
                            _c("v-tab", [_vm._v("Relationships")]),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _vm.loading
                  ? _c("v-skeleton-loader", { attrs: { type: "article" } })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.loading
                  ? _c(
                      "v-tabs-items",
                      {
                        model: {
                          value: _vm.tab,
                          callback: function ($$v) {
                            _vm.tab = $$v
                          },
                          expression: "tab",
                        },
                      },
                      [
                        _c("v-tab-item", { attrs: { value: 0 } }, [
                          _c(
                            "div",
                            {
                              staticClass: "flex flex-col gap-4 py-1",
                              class: { "pt-5": _vm.form.children.length },
                            },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "gap-4",
                                  attrs: { "no-gutters": "" },
                                },
                                [
                                  _c(
                                    "v-col",
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          rules: _vm.rules.input,
                                          dense: "",
                                          outlined: "",
                                          "hide-details": "auto",
                                          "prepend-inner-icon": "person",
                                          label: "First Name",
                                        },
                                        model: {
                                          value: _vm.form.first_name,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "first_name",
                                              $$v
                                            )
                                          },
                                          expression: "form.first_name",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          rules: _vm.rules.input,
                                          dense: "",
                                          outlined: "",
                                          "hide-details": "auto",
                                          label: "Last Name",
                                        },
                                        on: {
                                          input: function ($event) {
                                            _vm.form.children.forEach((e) => {
                                              if (e.last_name) return
                                              e.last_name = $event
                                            })
                                          },
                                        },
                                        model: {
                                          value: _vm.form.last_name,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "last_name", $$v)
                                          },
                                          expression: "form.last_name",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("SoliText", {
                                attrs: {
                                  errors: _vm.errors.email,
                                  rules: _vm.rules.email,
                                  icon: "alternate_email",
                                  label: "Email",
                                  "hide-details": "auto",
                                },
                                model: {
                                  value: _vm.form.email,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "email", $$v)
                                  },
                                  expression: "form.email",
                                },
                              }),
                              _vm._v(" "),
                              _c("SoliPhone", {
                                attrs: {
                                  icon: "phone",
                                  label: "Phone",
                                  errors: _vm.errors.phone,
                                  "hide-details": "auto",
                                },
                                model: {
                                  value: _vm.form.phone,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "phone", $$v)
                                  },
                                  expression: "form.phone",
                                },
                              }),
                              _vm._v(" "),
                              _c("SoliInstruments", {
                                attrs: {
                                  multiple: false,
                                  "return-object": false,
                                  "hide-details": "auto",
                                  notSure: "",
                                  autocomplete: "",
                                },
                                model: {
                                  value: _vm.form.instrument_id,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "instrument_id", $$v)
                                  },
                                  expression: "form.instrument_id",
                                },
                              }),
                              _vm._v(" "),
                              _c("SoliPrograms", {
                                attrs: {
                                  multiple: false,
                                  "return-object": false,
                                  "hide-details": "auto",
                                  notSure: "",
                                  autocomplete: "",
                                },
                                model: {
                                  value: _vm.form.program_id,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "program_id", $$v)
                                  },
                                  expression: "form.program_id",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-tab-item",
                          { attrs: { value: 1 } },
                          [
                            _c(
                              "v-expansion-panels",
                              {
                                attrs: { mandatory: "", accordion: "" },
                                model: {
                                  value: _vm.panel,
                                  callback: function ($$v) {
                                    _vm.panel = $$v
                                  },
                                  expression: "panel",
                                },
                              },
                              _vm._l(_vm.form.children, function (child, idx) {
                                return _c(
                                  "v-expansion-panel",
                                  { key: idx },
                                  [
                                    _c(
                                      "v-expansion-panel-header",
                                      {
                                        staticClass:
                                          "py-0 px-1 custom-panel-header font-semibold soli-grey",
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeEmpty()
                                          },
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            _vm.panel == idx
                                              ? {
                                                  key: "actions",
                                                  fn: function () {
                                                    return [
                                                      !child.permanent
                                                        ? _c(
                                                            "v-btn",
                                                            {
                                                              attrs: {
                                                                icon: "",
                                                                small: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.removeRelation(
                                                                      idx
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    color:
                                                                      "error",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "remove_circle_outline"
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                  proxy: true,
                                                }
                                              : null,
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              child.first_name
                                                ? `${child.first_name} ${child.last_name}`
                                                : child.permanent
                                                ? "Edit Relationship"
                                                : "New Relationship"
                                            ) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-expansion-panel-content",
                                      { staticClass: "custom-panel" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex flex-col gap-4 pt-1 pb-3",
                                          },
                                          [
                                            _c(
                                              "v-row",
                                              {
                                                staticClass: "gap-4",
                                                attrs: { "no-gutters": "" },
                                              },
                                              [
                                                _c(
                                                  "v-col",
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        "prepend-inner-icon":
                                                          "person",
                                                        label: "First Name",
                                                        outlined: "",
                                                        rules: _vm.rules.input,
                                                        dense: "",
                                                        "hide-details": "auto",
                                                      },
                                                      model: {
                                                        value: child.first_name,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            child,
                                                            "first_name",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "child.first_name",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-col",
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: "Last Name",
                                                        outlined: "",
                                                        rules: _vm.rules.input,
                                                        dense: "",
                                                        "hide-details": "auto",
                                                      },
                                                      model: {
                                                        value: child.last_name,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            child,
                                                            "last_name",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "child.last_name",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("v-select", {
                                              attrs: {
                                                items: _vm.relationshipOptions,
                                                "item-text": "relation",
                                                label: "Relationship",
                                                "return-object": "",
                                                value: child.inverse,
                                                outlined: "",
                                                dense: "",
                                                rules: _vm.rules.select,
                                                "prepend-inner-icon":
                                                  "handshake",
                                                "hide-details": "auto",
                                              },
                                              on: {
                                                change: (e) => (
                                                  (child.inverse = e.relation),
                                                  (child.relation = e.inverse)
                                                ),
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("SoliBirthday", {
                                              attrs: {
                                                label: "Birthday",
                                                "hide-details": "auto",
                                              },
                                              model: {
                                                value: child.birthday,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    child,
                                                    "birthday",
                                                    $$v
                                                  )
                                                },
                                                expression: "child.birthday",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("SoliPrograms", {
                                              attrs: {
                                                multiple: false,
                                                "return-object": false,
                                                "hide-details": "auto",
                                                notSure: "",
                                                autocomplete: "",
                                              },
                                              model: {
                                                value: child.program_id,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    child,
                                                    "program_id",
                                                    $$v
                                                  )
                                                },
                                                expression: "child.program_id",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("SoliInstruments", {
                                              attrs: {
                                                multiple: false,
                                                "return-object": false,
                                                "hide-details": "auto",
                                                notSure: "",
                                                autocomplete: "",
                                              },
                                              model: {
                                                value: child.instrument_id,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    child,
                                                    "instrument_id",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "child.instrument_id",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "extraBtn",
            fn: function () {
              return [
                _vm.form.children.length < 3 &&
                !_vm.loading &&
                !_vm.form.readonly
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "mb-4",
                        attrs: {
                          disabled: _vm.form.readonly,
                          rounded: "",
                          small: "",
                          plain: "",
                          block: "",
                          color: "accent",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.addChild()
                          },
                        },
                      },
                      [
                        _vm._v("Add Relationship"),
                        _c(
                          "v-icon",
                          { staticClass: "pl-1 pb-05", attrs: { small: "" } },
                          [_vm._v("person_add")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.valid,
          callback: function ($$v) {
            _vm.valid = $$v
          },
          expression: "valid",
        },
      }),
      _vm._v(" "),
      _vm.confirmConversion
        ? _c("SoliChoice", {
            ref: "confirmConversion",
            attrs: {
              title: "Are you sure?",
              subtitle:
                "This will convert this lead and any relationships to user accounts",
              loading1: "",
              button1: "Confirm",
              button2: "Cancel",
            },
            on: {
              option1: function ($event) {
                return _vm.handleConversion(true)
              },
              reset: function ($event) {
                _vm.confirmConversion = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }